import React from 'react';
type SectionHeadingProps = {
  kicker?: string;
  title: React.ReactNode;
  intro?: React.ReactNode;
  align?: 'left' | 'center';
  tone?: 'light' | 'dark';
  as?: 'h1' | 'h2';
  className?: string;
};
export function SectionHeading({
  kicker,
  title,
  intro,
  align = 'left',
  tone = 'light',
  as = 'h2',
  className = ''
}: SectionHeadingProps) {
  const Tag = as;
  const dark = tone === 'dark';
  return <div className={`${align === 'center' ? 'mx-auto text-center' : ''} max-w-3xl ${className}`} data-id="element-546" data-mp="myy57kpf7rc9">
      {kicker && <p className={`mb-4 flex items-center gap-3 text-sm font-medium ${align === 'center' ? 'justify-center' : ''} ${dark ? 'text-gold-300' : 'text-gold-700'}`} data-id="element-547" data-mp="i76ftdi03rnp">
          <span className={`h-px w-8 ${dark ? 'bg-gold-300/60' : 'bg-gold-700/50'}`} aria-hidden="true" data-id="element-548" data-mp="8aaebrqis5sn" />
          {kicker}
        </p>}
      <Tag className={`font-display text-4xl font-semibold leading-[1.08] md:text-5xl ${dark ? 'text-white' : 'text-ink'}`} data-id="element-549" data-mp="47nk5k6dm8sa">{title}</Tag>
      {intro && <p className={`mt-5 text-lg leading-relaxed ${dark ? 'text-white/70' : 'text-muted'}`} data-id="element-550" data-mp="1e0sxk0syfj7s">{intro}</p>}
    </div>;
}